import { hbs } from 'ember-cli-htmlbars';
export default hbs("{{#if @record.isPending}}\n  <Ui::LoadingSpinner @text={{t \'Uploading...\'}} />\n{{else}}\n  {{format-date @record.creationDate}}\n{{/if}}")